import {
  INTERCEPT_TOGGLE_TOOL_NAME,
  INTERCEPT_RULE_TOOL_NAME,
  LAUNCH_BROWSER_TOOL_NAME,
  MATCH_REPLACE_RULE_TOOL_NAME,
  PROXY_CONTROL_TOOL_NAME,
  PROXY_HISTORY_TOOL_NAME,
  REPLAY_REQUEST_TOOL_NAME,
  BROWSER_AUTOMATION_TOOL_NAME,
  TRACK_HISTORY_REQUEST_TOOL_NAME,
  TERMINAL_TOOL_NAMES,
  MCP_OAUTH_AUTHORIZE_TOOL_NAME,
  MCP_CREDENTIAL_DIALOG_TOOL_NAME,
} from '@terra/shared-dto-chat-types';
import { portalToolRegistry } from './portal-tool-registry';
import { proxyControlHandler } from './handlers/proxy-control.handler';
import { interceptToggleHandler } from './handlers/intercept-toggle.handler';
import { interceptRuleHandler } from './handlers/intercept-rule.handler';
import { matchReplaceRuleHandler } from './handlers/match-replace-rule.handler';
import { replayRequestHandler } from './handlers/replay-request.handler';
import { launchBrowserHandler } from './handlers/launch-browser.handler';
import { proxyHistoryHandler } from './handlers/proxy-history.handler';
import { browserAutomationHandler } from './handlers/browser-automation.handler';
import { trackHistoryRequestHandler } from './handlers/track-history-request.handler';
import { mcpOAuthAuthorizeHandler } from './handlers/mcp-oauth-authorize.handler';
import { mcpCredentialDialogHandler } from './handlers/mcp-credential-dialog.handler';
import type { PortalToolHandler } from './types';

export function registerPortalToolHandlers({
  terminalHandler,
}: {
  terminalHandler: PortalToolHandler;
}): void {
  portalToolRegistry.register(PROXY_CONTROL_TOOL_NAME, proxyControlHandler);
  portalToolRegistry.register(
    INTERCEPT_TOGGLE_TOOL_NAME,
    interceptToggleHandler,
  );
  portalToolRegistry.register(INTERCEPT_RULE_TOOL_NAME, interceptRuleHandler);
  portalToolRegistry.register(
    MATCH_REPLACE_RULE_TOOL_NAME,
    matchReplaceRuleHandler,
  );
  portalToolRegistry.register(REPLAY_REQUEST_TOOL_NAME, replayRequestHandler);
  portalToolRegistry.register(LAUNCH_BROWSER_TOOL_NAME, launchBrowserHandler);
  portalToolRegistry.register(PROXY_HISTORY_TOOL_NAME, proxyHistoryHandler);
  portalToolRegistry.register(
    BROWSER_AUTOMATION_TOOL_NAME,
    browserAutomationHandler,
  );
  portalToolRegistry.register(
    TRACK_HISTORY_REQUEST_TOOL_NAME,
    trackHistoryRequestHandler,
  );
  portalToolRegistry.register(
    MCP_OAUTH_AUTHORIZE_TOOL_NAME,
    mcpOAuthAuthorizeHandler,
  );
  portalToolRegistry.register(
    MCP_CREDENTIAL_DIALOG_TOOL_NAME,
    mcpCredentialDialogHandler,
  );
  TERMINAL_TOOL_NAMES.forEach((toolName) =>
    portalToolRegistry.register(toolName, terminalHandler),
  );
}
